import { useAppDispatch } from ".";
import { EQAuthParamType } from "src/Types";
import { BeginPauseParamsType, EQueueType } from "src/Types/ReDoc/EQueue";
import { DamaskRedirectParamType } from "src/Types/ReDoc/Damask";
import { 
	damaskGetConfig, damaskSaveConfig, damaskLogin, damaskStart, damaskGetOfficeStations, damaskDrop,
	damaskGetQueueState, damaskGetUserPult, damaskGetPauseReasons, damaskExit, damaskEndServing, damaskCall, damaskRedirect, 
	damaskDelay, damaskBeginServing, damaskRecall, damaskEndPause, damaskBeginPause, damaskCallById, damaskGetStations 
} from 'src/Slicers/eQueue/DamaskThunks';
import { enterGetConfig, enterStart, enterSaveConfig, enterGetStatus, enterCall, enterGetPauseReasons, enterBeginPause, enterEndPause, enterExit, 
	enterGetQueue, enterCallById, enterRecall, enterReject, enterBeginServing, enterGetDenyReasons, enterDelay, enterComplete, enterReason 
} from "src/Slicers/eQueue/EnterThunks";
import { returnBeginServing, returnCall, returnCallById, returnExit, returnGetConfig, returnGetQueue, returnGetQueueState, returnGetStatus, returnReject, returnSaveConfig, returnStart, returnTransfer, returnGetWindows, returnBeginPause, returnEndPause } from "src/Slicers/eQueue/ReturnThunks";



/** Возвращает объект с методами работы ЭО */
const useEQDispatch = ( type: EQueueType ) => {
	const dispatch = useAppDispatch();
	if ( type === EQueueType.None ) {
		throw new Error( "Не верно указан тип ЭО!" );
	}
	const empty =  { type: "empty" };
	const isDamask = type === EQueueType.Damask;
	const isReturn = type === EQueueType.Return;
	const rootAction = isDamask ? "eQueueDamask/" : isReturn ? "eQueueReturn/" : "eQueueEnter/";
	return {
		// Common
		dispatch: ( action: string, payload?: unknown ) => dispatch( { type: rootAction + action, payload } ),
		dispatchStd: dispatch,
		getConfig: () => dispatch( isDamask ? damaskGetConfig() : isReturn ? returnGetConfig() : enterGetConfig() ),
		saveConfig: ( payload: EQAuthParamType ) => dispatch( isDamask ? damaskSaveConfig( payload ) : isReturn ? returnSaveConfig( payload ) : enterSaveConfig( payload ) ),
		// Damask
		getOfficeStations: ( payload: string ) => dispatch( isDamask ? damaskGetOfficeStations( payload ) : empty ),
		getStations: () => dispatch( isDamask ? damaskGetStations() : empty ),
		getWindows: () => dispatch( isReturn ? returnGetWindows() : empty ),
		getUserPult: () => dispatch( isDamask ? damaskGetUserPult() : empty ),
		login: () => dispatch( isDamask ? damaskLogin() : empty ),
		redirect: ( payload: DamaskRedirectParamType ) => dispatch( isDamask ? damaskRedirect(payload) : empty ),

		// Enter
		getQuery: ( payload?: string ) => {
			if ( isDamask ) {
				return dispatch( empty );
			}
			if ( isReturn ) {
				return dispatch( returnGetQueue(payload) );
			}
			return dispatch( enterGetQueue() );
		},
		getDenyReasons: () => dispatch( isDamask ? empty : enterGetDenyReasons() ),
		reason: ( payload: string ) => dispatch( isDamask ? empty : enterReason(payload) ),

		start: ( payload: string ) => dispatch( isDamask ? damaskStart(payload) : isReturn ? returnStart(payload) : enterStart(payload) ),
		getQueueState: () => dispatch( isDamask ? damaskGetQueueState() : isReturn ? returnGetQueueState() : enterGetStatus() ),
		getStatus: () => dispatch( isDamask ? empty : isReturn ? returnGetStatus() : empty ),
		getPauseReasons: () => dispatch( isDamask ? damaskGetPauseReasons() : isReturn ? empty : enterGetPauseReasons() ),
		beginPause: ( payload: BeginPauseParamsType ) => {
			if ( isDamask ) return dispatch( damaskBeginPause(payload) );
			if ( isReturn ) return dispatch( returnBeginPause() );
			return dispatch( enterBeginPause(payload) );
		},
		endPause: () => {
			if ( isDamask ) return dispatch( damaskEndPause() );
			if ( isReturn ) return dispatch( returnEndPause() );
			return dispatch( enterEndPause() );
		},
		call: () => dispatch( isDamask ? damaskCall() : isReturn ? returnCall() : enterCall() ),
		callById: ( payload: string ) => {
			if ( isDamask ) {
				return dispatch( damaskCallById(payload) );
			}
			if ( isReturn ) {
				return dispatch( returnCallById(payload) );
			}
			return dispatch( enterCallById(payload) );
		},
		recall: () => dispatch( isDamask ? damaskRecall() : isReturn ? empty : enterRecall() ),
		drop: ( payload: string ) => {
			if ( isDamask ) return dispatch( damaskDrop(payload) );
			if ( isReturn ) return dispatch( returnReject() );
			return dispatch( enterReject(payload) );
		},
		beginServing: () => dispatch( isDamask ? damaskBeginServing() : isReturn ? returnBeginServing() : enterBeginServing() ),
		delay: ( payload: string ) => dispatch( isDamask ? damaskDelay(payload) : isReturn ? empty : enterDelay(payload) ),
		endServing: (  payload: string ) => dispatch( isDamask ? damaskEndServing(payload) : isReturn ? empty : enterComplete(payload) ), 
		redirectWindow: ( payload: string ) => dispatch( isReturn ? returnTransfer(payload) : empty ),

		exit: ( payload: string ) => {
			dispatch ( isDamask ? damaskExit( payload ) : isReturn ? returnExit( payload ) : enterExit( payload ) )
		}
	} as const;
};

export default useEQDispatch;
